<template>
  <div>
    <span v-if="isEdditing" v-on-clickaway="cancel">
      <form class="form-inline" @submit.prevent="save">
        <div class="input-group">
          <input type="number" class="form-control" v-model="newQuantity" style="width: 80px;">
          <span class="input-group-btn">
            <button type="submit" class="btn btn-success btn-noborder">
              <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
              <i class="fa fa-check" v-else></i>
            </button>
          </span>
        </div>
      </form>
    </span>

    <span @click="edit" v-else>
      <span class="editable text-primary" v-if="currentQuantity || currentQuantity === 0">{{currentQuantity}}</span>
      <span class="editable text-danger" v-else><i>n.n.b.</i></span>
    </span>

    <text-alert :alert.sync="alert"></text-alert>
  </div>
</template>

<script>
import http from '../utils/http'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  props: ['quantity', 'productId'],
  data () {
    return {
      currentQuantity: this.quantity,
      newQuantity: this.quantity,
      isEdditing: false,
      isLoading: false,
      alert: false
    }
  },
  created () {
    this.$root.$on('product-stock-updated', this.onUpdate)
  },
  destroy () {
    this.$root.$off('product-stock-updated', this.onUpdate)
  },
  methods: {
    edit () {
      this.isEdditing = true
      this.newQuantity = this.currentQuantity
    },
    cancel () {
      this.isEdditing = false
    },
    save () {
      this.isLoading = true

      const data = {
        stock_quantity: this.newQuantity
      }

      return http.patch(`/products/${this.productId}`, data)
        .then((response) => {
          this.currentQuantity = this.newQuantity
          this.isEdditing = false
          this.isLoading = false

          this.alert = { variant: 'success', message: 'Opgeslagen' }

          this.$root.$emit('product-stock-updated', {
            product_id: this.productId,
            quantity: this.newQuantity
          })
        })
        .catch(() => {
          this.isLoading = false
          this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' }
        })
    },
    onUpdate (e) {
      if (this.productId === e.product_id) {
        this.currentQuantity = e.quantity
        this.newQuantity = e.quantity
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// StockEditable.vue?1cb04c10